import { useAppSelector } from '@src/core/hooks';
import { useWidgetId } from '@src/core/IdProvider';
import {
  productPackageProductsSelector,
  productPackageSelector,
  productPackageTotalPriceSelector,
} from '@src/stores/product';
import { shouldUseSingleBookingPackageBooking } from '@src/domains/productPackage';
import useFeatureFlag from './useFeatureFlag';
import usePackageIdParam from './usePackageIdParam';

export const usePackageBooking = () => {
  const widgetId = useWidgetId();
  const packageId = usePackageIdParam()!;
  const { isFeatureFlagEnabled } = useFeatureFlag();

  const productPackageProducts = useAppSelector(productPackageProductsSelector(packageId));
  const productPackage = useAppSelector(productPackageSelector(packageId));
  const packageTotalCents = useAppSelector(productPackageTotalPriceSelector(widgetId, packageId));

  const products = (productPackageProducts ?? []).map(({ product }) => product!);
  const isSingleBooking = shouldUseSingleBookingPackageBooking(
    productPackage?.configurationMode,
    isFeatureFlagEnabled('PR-4664-product-package-single-journey'),
  );

  return {
    products,
    packageTotalCents,
    isSingleBooking,
  };
};

export default usePackageBooking;
